import { CSSProperties } from 'react';
import ReactDOM from 'react-dom';
import { RequestOptionConfig } from '.';
import { getLabel } from '../locale';
import { AnyObj } from '../monitor/types';
import { ua } from '../ua';

const isMobile = ua.device !== 'PC';

sessionStorage.removeItem('weappRequestSensitiveModalVisible'); //  清除上一次记录

export const showMobileTip = (message: string | React.ReactNode) => {
  const Alert = window.weappUi?.Alert || window.weappUi?.default?.Alert;
  const Icon = window.weappUi?.Icon || window.weappUi?.default?.Icon;
  if (Alert && Icon) {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const destroy = () => {
      const unmount = ReactDOM.unmountComponentAtNode(div);
      if (unmount && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }
    const style = { border: 0, backgroud: '#ECF5FF' };
    ReactDOM.render(<div style={{ position: 'fixed', left: 0, top: 0, width: '100%' }}>
      <Alert
        message={message}
        type="info"
        showIcon
        onClose={destroy}
        style={style}
        closable
        icon={(<Icon name={'Icon-remind01'} size="lg" style={{ color: '#5D9CEC' }} />)}
        closeText={(<Icon name={'Icon-cancel'} size="lg" />)}
      />
    </div>, div);
  }
}

export const showMessage = (message: string | React.ReactNode, type: string, otherParams?: AnyObj) => {
  if (window.weappUi) {
    if (!isMobile) {
      const Dialog = window.weappUi?.Dialog || window.weappUi?.default?.Dialog;
      if (Dialog) {
        Dialog.message({
          type,
          content: message,
          forbidDisappearingOnMouseenter: true,
          ...otherParams,
        })
      }
    } else {
      showMobileTip(message);
    }
  }
}

export const showConfirm = (otherParams: any, superviseType: string) => {
  if (window.weappUi) {
    const weak = superviseType === 'weak'; // 弱控
    const content = (
      <div style={{ textAlign: 'center', fontWeight: 400, lineHeight: 1.5 }}>
        {
          !weak ? otherParams?.weakConfirmTip || (<div>
            {getLabel('152655', '页面内容存在敏感词，请修改后再操作！')}
          </div>) : otherParams?.strongConfirmTip || (
            <>
              <div>{getLabel('152656', '页面内容存在敏感词,确定要提交吗？')}</div>
              <div>({getLabel('152657', '提交后系统将根据敏感词规则自动处理')})</div>
            </>
          )}
      </div >
    )
    let instance: { onClose: () => void; } | null = null;
    const getInstance = (el: { onClose: () => void; } | null) => instance = el;
    const onCancel = () => {
      // 增加避免提示框重复弹出处理
      sessionStorage.setItem('weappRequestSensitiveModalVisible', 'false');
      
      instance?.onClose?.();
      otherParams?.onCancel?.();
    }
    const onOk = () => {
      // 增加避免提示框重复弹出处理
      sessionStorage.setItem('weappRequestSensitiveModalVisible', 'false');

      instance?.onClose?.();
      otherParams?.onOk?.(superviseType);
    }
    if (!isMobile) {
      const Dialog = window.weappUi?.Dialog || window.weappUi?.default?.Dialog;
      const Button = window.weappUi?.Button || window.weappUi?.default?.Button;
      const Icon = window.weappUi?.Icon || window.weappUi?.default?.Icon;
      if (Dialog && Button) {
        const footer = !weak ? <Button type="primary" key="sure" onClick={onCancel}>{getLabel('139819', '确定')}</Button> : [
          <Button type="primary" key="sure" onClick={onOk}>{getLabel('139819', '确定')}</Button>,
          <Button key="cancel" onClick={onCancel}>{getLabel('52130', '取消')}</Button>
        ]
        Dialog.confirm({
          content,
          footer,
          getInstance,
          closeIcon: (<div key="close" className={`ui-dialog-icon ui-dialog-closeIcon ui-confirm-closeIcon`} onClick={onCancel}>
            <Icon name='Icon-error01' size="sm" />
          </div>)
        })
      }
    } else {
      const MDialog = window.weappUi?.MDialog || window.weappUi?.default?.MDialog;
      if (MDialog) {
        const footer = !weak ? [
          {
            key: 'sure',
            text: getLabel('139819', '确定'),
            type: 'primary',
            onPress: onCancel,
          }
        ] : [
          {
            key: 'sure',
            text: getLabel('139819', '确定'),
            onPress: onOk,
            type: 'primary',
          },
          {
            key: 'cancel',
            text: getLabel('52130', '取消'),
            onPress: onCancel,
          }
        ]
        MDialog.prompt({
          prompt: false,
          title: getLabel('152658', '信息确认'),
          mask: true,
          message: content,
          footer,
          getInstance,
          width: '85%',
        })
      }
    }
  }
}

export const addSensitiveWordconfirm = (optionsData: any) => {
  let data = optionsData;
  if (typeof data === 'string') data = `${data}&sensitiveWordconfirm=1`;
  else if (data instanceof FormData) data.append('sensitiveWordconfirm', '1');
  else data = {
    ...data,
    sensitiveWordconfirm: 1,
  }
  return data;
}
/**
 * sensitiveWordconfirm=1, 跳过敏感词检测
 * @param options 接口参数配置
 * @returns 
 */
export const replaceSensitiveData = (options: RequestOptionConfig) => {
  if (options.data) {
    return {
      ...options,
      params: addSensitiveWordconfirm(options.params || {}),
      // data: addSensitiveWordconfirm(options.data),
    }
  }
  return {
    ...options,
    params: addSensitiveWordconfirm(options.params),
  }
}

/**
 * 敏感词预检处理
 * @param data 接口返回数据
 * @param otherParams 其他配置
 * @returns 
 */
export const doSensitiveScan = (data: any, otherParams: any, skipSensitiveScan?: boolean) => {
  if (data) {
    const { sensitiveScanCode, superviseType, data: _data } = data;
    if (sensitiveScanCode === 401) {
      // 增加避免提示框重复弹出处理
      const sensitiveModalVisible = sessionStorage.getItem('weappRequestSensitiveModalVisible') === 'true';
      if (!sensitiveModalVisible) {
        const mainColor = isMobile ? '#5D9CEC' : '#333';
        const tipColor = isMobile ? '#FF4D4F' : '#FF5757';
        const divStyle: CSSProperties = isMobile ? { textAlign: 'left', fontSize: 14 } : { textAlign: 'left' }
        showMessage(<div style={divStyle}>
          <span style={{ color: mainColor }}>{otherParams?.message || getLabel('152659','页面内容存在以下敏感词：')}</span>
          <span style={{ color: tipColor }}>
            {_data?.sensitiveWords}
          </span></div>, "info", { delay: 5000 });
        showConfirm(otherParams, superviseType);

        // 增加避免提示框重复弹出处理
        sessionStorage.setItem('weappRequestSensitiveModalVisible', 'true');
      }
      return {
        pass: false,
      };
    } else if (sensitiveScanCode === 200 && !skipSensitiveScan) {
      // showMessage("恭喜！表单内容未发现敏感词！", "success");
    }
  }
  return {
    pass: true,
  };
}
